import { connect } from "react-redux";
import Calculs from "../components/Calculs";
import {
  changeCalculsPage,
  changeCalculsSearch,
  closeCalculsFiltersSection,
  loadUserCalculs,
  openCalculsFiltersSection,
  updateCalculsFilters,
  updateCalculsLimit,
} from "../actions";
import { getLocalEDECIntegration } from "../../user/actions";
import {
  changeFoldersPage,
  createFolder,
  loadUserFolders,
  updateFoldersLimit,
} from "../../folders/actions";
import { defaultCalculsFilters } from "../constants";

export default connect(
  (state) => ({
    calculs: state.calculs.calculs,
    isCalculsLoading: state.calculs.isLoading,
    calculsCurrentPage: state.calculs.currentPage,
    calculsLimit: state.calculs.limit,
    calculsTotal: state.calculs.total,
    isGeneratingReports: state.loader.isGeneratingReports,
    localConfigurator: state.configurator.localConfigurator,
    isFoldersLoading: state.folders.isLoading,
    foldersCurrentPage: state.folders.currentPage,
    foldersLimit: state.folders.limit,
    foldersTotal: state.folders.total,
    calculsSearch: state.calculs.search,
    isDownloadingReports: state.loader.isDownloadingReports,
    isFilterSectionOpen: state.calculs.isFilterSectionOpen,
    calculsFilters: state.calculs.filters || defaultCalculsFilters,
  }),
  (dispatch) => ({
    loadUserCalculs: () => {
      dispatch(loadUserCalculs());
    },
    changeCalculsPage: (page) => {
      dispatch(changeCalculsPage(page));
    },
    getLocalEDECIntegration: () => {
      dispatch(getLocalEDECIntegration());
    },
    updateCalculsLimit: (limit) => {
      dispatch(updateCalculsLimit(limit));
    },
    loadUserFolders: () => {
      dispatch(loadUserFolders());
    },
    changeFoldersPage: (page) => {
      dispatch(changeFoldersPage(page));
    },
    updateFoldersLimit: (limit) => {
      dispatch(updateFoldersLimit(limit));
    },
    createFolder: (folderDatas) => {
      dispatch(createFolder(folderDatas));
    },
    changeCalculsSearch: (search) => {
      dispatch(changeCalculsSearch(search));
    },
    openCalculsFiltersSection: () => {
      dispatch(openCalculsFiltersSection());
    },
    closeCalculsFiltersSection: () => {
      dispatch(closeCalculsFiltersSection());
    },
    updateCalculsFilters: (filters) => {
      dispatch(updateCalculsFilters(filters));
    },
  }),
)(Calculs);
